import { Box } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { CustomerContext } from "./Context/CustomerContext";

const CustomerEdit = () => {
  const [visibleOldPassword, setVisibleOldPassword] = useState(false);
  const [visibleNewPassword, setVisibleNewPassword] = useState(false);
  const [visibleNewPasswordConfirm, setVisibleNewPasswordConfirm] =
    useState(false);

  const [firstName, setFirstName] = useState(``);
  const [lastName, setLastName] = useState(``);
  const [visibleName, setVisibleName] = useState(``);
  const [email, setEmail] = useState(``);
  const [oldPassword, setOldPassword] = useState(``);
  const [newPassword, setNewPassword] = useState(``);
  const [newPasswordConfirm, setNewPasswordConfirm] = useState(``);
  const { customerData, setCustomerData } = useContext(CustomerContext);

  const clientId = localStorage.getItem("client_id");
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setEmail(customerData.email);
    setVisibleName(customerData.visibleName);
    setFirstName(customerData.firstName ?? "");
    setLastName(customerData.lastName ?? "");
  };

  const handleVisibleOldPassword = () => {
    setVisibleOldPassword(!visibleOldPassword);
  };

  const handleVisibleNewPassword = () => {
    setVisibleNewPassword(!visibleNewPassword);
  };

  const handleVisibleNewPasswordConfirm = () => {
    setVisibleNewPasswordConfirm(!visibleNewPasswordConfirm);
  };

  const handleUpdate = () => {
    const formData = {
      firstName: firstName,
      lastName: lastName,
      visibleName: visibleName,
      email: email,
    };
    if (
      (oldPassword && oldPassword.trim() !== "") ||
      (newPassword && newPassword.trim() !== "") ||
      (newPasswordConfirm && newPasswordConfirm.trim() !== "")
    ) {
      if (oldPassword.trim() == "") {
        toast("Vui lòng nhập mật khẩu cũ!", {
          type: "error",
          autoClose: 1000,
        });
        return;
      }
      if (newPassword != newPasswordConfirm) {
        toast("Xác nhận mật khẩu không đúng!", {
          type: "error",
          autoClose: 1000,
        });
        return;
      }
      formData.oldPassword = oldPassword;
      formData.newPassword = newPassword;
    }
    axios
      .put(`/api/v1/customers/` + clientId, formData)
      .then((res) => {
        setCustomerData((prevData) => ({
          ...prevData,
          ...res.data,
        }));
        toast("Lưu thay đổi thành công!", {
          type: "success",
          autoClose: 1000,
        });
      })
      .catch((err) => {
        toast(err.response.data.message, {
          type: "error",
          autoClose: 1000,
        });
      });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <div className="customer-edit-top">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "30px",
          }}
        >
          <div>
            <div className="login-signup-label">
              Tên <i className="">*</i>
            </div>
            <div className="login-signup-box">
              <input
                type="text"
                className="login-signup-input"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
          </div>
          <div>
            <div className="login-signup-label">
              Họ <i className="">*</i>
            </div>
            <div className="login-signup-box">
              <input
                type="text"
                className="login-signup-input"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="login-signup-label">
          Tên hiển thị <i className="">*</i>
        </div>
        <div className="login-signup-box">
          <input
            type="text"
            className="login-signup-input"
            value={visibleName}
            onChange={(e) => setVisibleName(e.target.value)}
          />
        </div>
        <i>
          Tên này sẽ hiển thị trong trang Tài khoản và phần Đánh giá sản phẩm
        </i>
        <div className="login-signup-label">
          Địa chỉ email <i className="">*</i>
        </div>
        <div className="login-signup-box">
          <input
            type="text"
            className="login-signup-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </div>
      <div className="customer-edit-bottom">
        <div className="customer-edit-bottom-title">THAY ĐỔI MẬT KHẨU</div>
        <div className="login-signup-label">
          Mật khẩu hiện tại (bỏ trống nếu không đổi)
        </div>
        <div className="login-signup-box">
          <input
            type={visibleOldPassword ? "text" : "password"}
            className="login-signup-input"
            onChange={(e) => setOldPassword(e.target.value)}
          />
          <i
            className={`bi ${visibleOldPassword ? "bi-eye-slash" : "bi-eye"}`}
            onClick={handleVisibleOldPassword}
          ></i>
        </div>
        <div className="login-signup-label">
          Mật khẩu mới (bỏ trống nếu không đổi)
        </div>
        <div className="login-signup-box">
          <input
            type={visibleNewPassword ? "text" : "password"}
            className="login-signup-input"
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <i
            className={`bi ${visibleNewPassword ? "bi-eye-slash" : "bi-eye"}`}
            onClick={handleVisibleNewPassword}
          ></i>
        </div>
        <div className="login-signup-label">Xác nhận mật khẩu mới</div>
        <div className="login-signup-box">
          <input
            type={visibleNewPasswordConfirm ? "text" : "password"}
            className="login-signup-input"
            onChange={(e) => setNewPasswordConfirm(e.target.value)}
          />
          <i
            className={`bi ${
              visibleNewPasswordConfirm ? "bi-eye-slash" : "bi-eye"
            }`}
            onClick={handleVisibleNewPasswordConfirm}
          ></i>
        </div>
        <button className="login-signup-button" onClick={handleUpdate}>
          Lưu thay đổi
        </button>
      </div>
    </Box>
  );
};

export default CustomerEdit;
